'use client'
import {
  minifyGqlQuery
} from "./chunk-SQE4KWHX.mjs";
import {
  PAGE_SECTION_QUERY
} from "./chunk-46Z5IX3R.mjs";
import {
  SCHEDULE_QUERY
} from "./chunk-5GNKV3HD.mjs";
import {
  IMAGE_QUERY
} from "./chunk-AFUSNP5S.mjs";
import {
  SECTIONS_LIMIT
} from "./chunk-HVHRQLH6.mjs";
import {
  getContentfulSafeLocale
} from "./chunk-2QEV6CST.mjs";
import {
  gqlClient
} from "./chunk-DZ54PK2S.mjs";
import {
  __async,
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/api/season/listing.ts
import { useQuery } from "@tanstack/react-query";
import { Exception } from "@wbk/logger";
import { gql } from "graphql-request";
var QUERY = gql`
query getSeasons($lang: String, $limit: Int, $skip: Int, $where: SeasonFilter) {
  seasonCollection(locale: $lang, limit: $limit, skip: $skip, where: $where) {
    items {
      id
      title
      subtitle
      slug
      logo {${IMAGE_QUERY}}
      background {${IMAGE_QUERY}}
      schedule {${SCHEDULE_QUERY}} 
      sectionsCollection(limit: ${SECTIONS_LIMIT}) {
        items {
          __typename
          ${PAGE_SECTION_QUERY}
        }
      }
    }
  }
}`;
var getSeasons = (_a) => __async(void 0, null, function* () {
  var _b = _a, { lang = "en" } = _b, props = __objRest(_b, ["lang"]);
  try {
    const res = yield gqlClient.request(
      minifyGqlQuery(QUERY),
      __spreadProps(__spreadValues({}, props), {
        lang: getContentfulSafeLocale(lang)
      })
    );
    return res.seasonCollection.items;
  } catch (error) {
    throw new Exception({ error, name: "getSeasonsException" });
  }
});
var useGetSeasons = (props) => {
  return useQuery({
    queryKey: ["seasons", props],
    queryFn: () => getSeasons(props)
  });
};

export {
  useGetSeasons
};
//# sourceMappingURL=chunk-R6UFW4GD.mjs.map